import apiClient from './api-client';

export interface VaultActualValueResponse {
    vaultId: number;
    originalValue: string;
}

export interface VaultMaskedTokenResponse {
    vaultId: number;
    partiallyMaskedToken: string;
}

export interface VaultResponse {
    success: boolean;
    data: VaultActualValueResponse | VaultMaskedTokenResponse;
}

class VaultService {
    /**
     * Get the actual value from vault using vault ID
     * @param vaultId - The vault ID
     * @returns Promise with the actual value
     */
    async getActualValue(vaultId: number): Promise<VaultActualValueResponse> {
        const response = await apiClient.get<VaultResponse>(`/vault/actual/${vaultId}`);
        return response.data as VaultActualValueResponse;
    }

    /**
     * Get the masked token from vault using vault ID
     * @param vaultId - The vault ID
     * @returns Promise with the masked token
     */
    async getMaskedToken(vaultId: number): Promise<VaultMaskedTokenResponse> {
        const response = await apiClient.get<VaultResponse>(`/vault/masked/${vaultId}`);
        return response.data as VaultMaskedTokenResponse;
    }
}

// Export a singleton instance
export const vaultService = new VaultService();
